import { logger } from "@jslib/shared/utils/logger";

import { getInstallPageUrl, getInstallType, getPublishedVersion } from "./ApiUrls";

/**
 * Client identification the backend uses to attribute a verification to a
 * client, version, and install context. Sent as headers on API calls and as
 * query string params on navigations that start SSO. HTTP header names are
 * case-insensitive, query string params are not, so both carry these names
 * exactly as spelled here.
 */
export const getClientParams = (): Record<string, string> => ({
  clientName: "jslib",
  clientVersion: getPublishedVersion(),
  installType: getInstallType(),
  installUrl: getInstallPageUrl() || "",
  projectSha: window.sheerIdProjectSha || "",
});

/**
 * Carry the client params on a navigation to the SheerID platform, which has no
 * request of its own to put headers on.
 */
export const appendClientParams = (url: string): string => {
  try {
    const destination = new URL(url);

    Object.entries(getClientParams())
      .filter(([, value]) => value)
      .forEach(([name, value]) => destination.searchParams.set(name, value));

    return destination.toString();
  } catch (e) {
    // Reporting the client is never worth losing the navigation over.
    logger.error(e, "appendClientParams");
    return url;
  }
};
